// FILE: src/features/onboardingSlice.js
// Pre-course steps (MTO 12.4–12.6, plan WP-6): the server says which are done
// (GET /api/onboarding); lessons stay closed until all are.
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getOnboarding } from "../services/courseInfo";

export const fetchOnboarding = createAsyncThunk("onboarding/fetch", async (_, { rejectWithValue }) => {
  try {
    return await getOnboarding();
  } catch (err) {
    return rejectWithValue(err.body || { code: err.code || err.message });
  }
});

const onboardingSlice = createSlice({
  name: "onboarding",
  initialState: { data: null, loading: false, error: null },
  reducers: {
    onboardingReceived(state, action) {
      state.data = action.payload;
    }
  },
  extraReducers: (b) => {
    b.addCase(fetchOnboarding.pending, (s) => {
      s.loading = true;
      s.error = null;
    })
      .addCase(fetchOnboarding.fulfilled, (s, a) => {
        s.loading = false;
        s.data = a.payload;
      })
      .addCase(fetchOnboarding.rejected, (s, a) => {
        s.loading = false;
        s.error = a.payload;
      });
  }
});

export const { onboardingReceived } = onboardingSlice.actions;
export const selectOnboardingComplete = (state) => state.onboarding?.data?.complete;
export default onboardingSlice.reducer;
